// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__lvkgp","title":"Info_title__2LmkO","selects":"Info_selects__idaxO","requiredAsterisk":"Info_requiredAsterisk__31sib"};